export const GET_LOCAL_USER_REQUEST='GET_LOCAL_USER_REQUEST'
export const GET_LOCAL_USER_SUCCESS='GET_LOCAL_USER_SUCCESS'
export const GET_LOCAL_USER_FAILURE='GET_LOCAL_USER_FAILURE'

